"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentDefaultProps = exports.componentPropTypes = exports.styleClassNames = exports.styleClassName = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// JedWatson/classnames
// --------------------
//
// This is a PropType definition that is suitable for converting to a HTML 'class' attribute value.
// See: https://github.com/JedWatson/classnames
var styleClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]);

exports.styleClassName = styleClassName;
var styleClassNames = {
  rowClassName: styleClassName,
  labelClassName: styleClassName,
  elementWrapperClassName: styleClassName
};
exports.styleClassNames = styleClassNames;

var componentPropTypes = _objectSpread(_objectSpread({}, styleClassNames), {}, {
  onChange: _propTypes["default"].func,
  onSetValue: _propTypes["default"].func,
  isPristine: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].arrayOf(_propTypes["default"].node),
  help: _propTypes["default"].string,
  info: _propTypes["default"].string,
  footer: _propTypes["default"].string,
  label: _propTypes["default"].node,
  layout: _propTypes["default"].oneOf(['horizontal', 'vertical', 'elementOnly']),
  showErrors: _propTypes["default"].bool
});

exports.componentPropTypes = componentPropTypes;
var componentDefaultProps = {
  onChange: function onChange() {},
  onSetValue: function onSetValue() {},
  errorMessages: [],
  help: null,
  info: null,
  footer: null,
  label: null,
  layout: 'horizontal',
  showErrors: true
};
exports.componentDefaultProps = componentDefaultProps;